<template>
  <el-row class="wrapper flex-fill px-3 px-md-5 mt-5">
    <el-col :sm="{ span: 12, offset: 6 }" :md="{ span: 12, offset: 6 }" :lg="{ span: 8, offset: 8 }" :xl="{ span: 10, offset: 7 }">
      <div class="d-flex flex-column gap-3 justify-content-center h-100 form-wrapper">
        <div class="d-flex mb-4 align-items-center justify-content-center logo">
          <img id="logo" :src="userStore.domain?.logo ?? defaultLogoPathWhite" />
        </div>
        <div class="bg-white p-4">
          <h3 class="mb-4">Reset Your Password</h3>
          <el-form ref="dataForm" :model="resetPasswordState" label-position="top" require-asterisk-position="right" @submit="updatePassword">
            <el-form-item
              label="Email or Username"
              prop="email"
              required
              class="form-text"
              :rules="{
                required: true,
                message: $t('error.vuelidate.required'),
              }"
            >
              <el-input v-model="resetPasswordState.email" class="custom-input" type="text" />
            </el-form-item>
            <el-form-item
              label="Password"
              prop="password"
              required
              class="form-text"
              :rules="{
                required: true,
                message: $t('error.vuelidate.required'),
              }"
            >
              <el-input v-model="resetPasswordState.password" class="custom-input" type="password" autocomplete="off" />
            </el-form-item>

            <el-form-item
              label="Password Confirmation"
              prop="password_repeat"
              required
              class="form-text"
              :rules="{
                required: true,
                message: $t('error.vuelidate.required'),
              }"
            >
              <el-input v-model="resetPasswordState.password_repeat" class="custom-input" type="password" autocomplete="off" />
            </el-form-item>
            <el-form-item>
              <div class="d-grid w-100 pt-2">
                <el-button class="button" type="primary" native-type="submit" :disabled="isLoading">
                  <span v-if="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  <span v-else>Update Password</span>
                </el-button>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div class="d-flex flex-column align-items-center gap-3 fw-normal mt-4">
          <el-text><a href="/login" class="text-primary text-decoration-none">{{ $t('components.login.backToLoginButton') }}</a></el-text>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-facing-decorator';
import { ElForm, ElMessage } from 'element-plus';

import { endpointAuthSystem } from '@/services/api/api';
import { useUserStore } from '@/stores/userStore';
import { defaultLogoPathWhite } from '@/utils/theme';

interface ResetPasswordState {
  email: string;
  password: string;
  password_repeat: string;
}

@Component
export default class ResetPassword extends Vue {
  resetPasswordState: ResetPasswordState = {
    email: '',
    password: '',
    password_repeat: '',
  };
  isLoading = false;
  defaultLogoPathWhite = defaultLogoPathWhite;
  userStore = useUserStore();

  async updatePassword(event: Event | null = null): Promise<void> {
    if (event) event.preventDefault();

    const dataForm = this.$refs.dataForm as InstanceType<typeof ElForm>;
    dataForm?.validate(async (valid: boolean) => {
      if (valid) {
        this.isLoading = true;
        try {
          if (this.resetPasswordState.password !== this.resetPasswordState.password_repeat) {
            ElMessage.error(this.$t('error.vuelidate.passwordNotMatch'));
            return;
          }
          const formData = new FormData();
          formData.append('uid_field', this.resetPasswordState.email);
          formData.append('password', this.resetPasswordState.password);
          formData.append('password_repeat', this.resetPasswordState.password_repeat);

          const api = endpointAuthSystem();

          await api.post('api/cekoon/login/authentik/reset-password', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          });
          ElMessage.success(this.$t('success.api.emailSent'));
        } catch (error: unknown) {
          console.error('error submit: ',error)
          ElMessage.error(this.$t('error.api.server'));
        } finally {
          this.isLoading = false;
        }
      } else {
        ElMessage.error(this.$t('error.vuelidate.required'));
      }
    });
  }
}
</script>


<style scoped>
.wrapper {
  height:8vh;
}
.form-wrapper{
  /* padding-bottom:4rem; */
}
.button {
  width: 100%;
  color: white;
  background-color: #1d1e19;
  border: none;
}

.button:hover {
  background-color: #353535;
}
#logo {
  max-height: 3.4rem;
}
.custom-input::v-deep(.el-input__wrapper) {
  padding: 1px !important;
}
.custom-input::v-deep(.el-input__inner) {
  border-radius: 4px !important;
  padding: 1px 11px !important;
}
</style>
